<template>
  <div class="page-facility-sections">
    <tabbed-view :tabs="tabs" :fixed-title="title">
    </tabbed-view>
  </div>
</template>

<script>

import TabbedView from '@/views/components/tabs/TabbedView';

export default {
  name: 'Section',
  components: {
    TabbedView,
  },
  data() {
    return {
      title: null,
      tabs: [
        {
          label: 'Section Details',
          route: 'facilities.sections.view',
        },
        {
          label: 'Lloyds Risk Codes',
          route: 'facilities.sections.riskCodes.list',
        },
        {
          label: 'Products',
          route: 'facilities.sections.products.list',
        },
        {
          label: 'Ancestors',
          route: 'facilities.sections.ancestors.list',
        },
      ]
    };
  },
  async mounted() {
    this.title = await this.setTitle(this.$route.params.sectionId);
  },
  methods: {
    async setTitle(id) {
      const { data } = await this.$api.facilities.sections.get(id);
      if (data.data) {
        return `Section: ${data.data.Section}`;
      }
      return '';
    },
  },
  watch: {
    $route: {
      handler: async function(to, from) {
        const toId = to.params.sectionId;
        const fromId = from.params.sectionId;
        if (toId != fromId) {
          this.title = await this.setTitle(toId);
        }
      }
    },
  }
};
</script>
